import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  title: {
    id: 'product_jp_modal_condition_title',
    defaultMessage: 'About condition',
  },
  about: {
    id: 'product_jp_product_condition_paragraph',
    defaultMessage:
      '"Product condition" refers to the appearance of the device, such as the body and screen. While the condition and price vary by grade, all products are guaranteed to function 100% properly, with no difference in performance.',
  },
} as Record<string, I18nDefinition>
